import {
  Box, Typography, TextField, Button,
} from '@mui/material';
import { useRecordContext, useInput } from 'react-admin';
import React from 'react';
import { getUserData } from 'authProvider';

export function DescriptionInput(props) {
  const [newText, setNewText] = React.useState('');

  const {
    field,
  } = useInput(props);
  const user = getUserData();
  const text = `#${user?.id}${user?.information?.firstName ? ` ${user.information.firstName}` : ''}: ${newText} - 🗓️ ${new Date().toLocaleDateString('fa-IR')}`;
  const handleAdd = () => {
    const updatedDescription = field.value ? `${field.value}|${text}` : text;
    field.onChange(updatedDescription);
    setNewText('');
  };

  return (
    <Box>
      {field.value && (
        <Box sx={{ direction: 'rtl' }}>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            direction: 'rtl',
            textAlign: 'right',
          }}
          >
            {field.value.split('|').map((line) => (
              <li key={line}>
                <Typography variant="body2" color="textSecondary">{line}</Typography>
              </li>
            ))}
          </ul>
        </Box>
      )}
      <Box sx={{
        mb: 3, display: 'flex', gap: 1, alignItems: 'center',
      }}
      >
        <TextField
          multiline
          fullWidth
          value={newText}
          onChange={(e) => setNewText(e.target.value)}
          size="small"
          label="توضیحات ..."
        />
        <Button variant="contained" onClick={handleAdd}>
          ثبت
        </Button>
      </Box>
    </Box>
  );
}
